<template>
    <div class="xl:min-h-screen bg-gray-50 py-12">
      <div class="container mx-auto px-6 text-center">
        <h1 class="text-4xl font-bold text-[#085f63] mb-6">{{ $t('contactPage.title') }}</h1>
        <p class="text-lg text-gray-600 mb-12">{{ $t('contactPage.description') }}</p>

        <div class="max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-lg">
          <ContactForm />
        </div>
      </div>
    </div>
</template>

<script>
import ContactForm from '@/components/contact/ContactForm.vue'

export default {
  components: {
    ContactForm
  }
}
</script>
